const OBJECT_URL_LIFETIME_MS = 60_000;

/**
 * Abre um arquivo em outra aba mesmo quando a URL assinada força o download (Content-Disposition: attachment).
 * O arquivo é buscado e aberto como blob, que o navegador exibe pelo Content-Type em vez de baixar.
 * A aba é aberta antes do fetch para o navegador não bloquear o pop-up.
 */
export const openFileInNewTab = async (url: string) => {
  const tab = window.open("", "_blank");

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Falha ao carregar o arquivo (${response.status})`);

    const objectUrl = URL.createObjectURL(await response.blob());

    if (tab) tab.location.href = objectUrl;
    else window.open(objectUrl, "_blank");

    setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_LIFETIME_MS);
  } catch (error) {
    tab?.close();
    throw error;
  }
};
